/**
 * Query to fetch cliente coordinates with additional address information
 */
const clienteCoordsQuery = `
query FindClienteCoords {
  cliente_coords (
    first: 10000,
    where: {
      org_pointer: {
        have: {
          objectId: {
            equalTo: "1VtPmaMogI"
          }
        }
      }
    }
  ) {
    edges {
      node {
        objectId
        latitude
        longitude
        cliente_pointer {
          objectId
          nome
          cognome
          indirizzo
          citta
          cap
          nazionalita
        }
      }
    }
  }
}`.replace(/\r?\n|\r/g, "").replace(/\t/g, " ");

export default clienteCoordsQuery;